module.exports = __webpack_public_path__ + "img/web3.e31175c1.png";